import type { ConfigWarning, WarningSeverity } from "@models/mappingConfig";

export const SEVERITY_ORDER: WarningSeverity[] = ["blocking", "warning", "info"];

/** Identity of one warning in the acknowledgement state (two warnings can share a code). */
export const warningId = (warning: ConfigWarning, index: number): string =>
  `${warning.code}|${warning.path ?? ""}|${index}`;

/** Approve is allowed when nothing blocks and every `warning` is acknowledged; `info` never gates. */
export const canApprove = (warnings: ConfigWarning[], acknowledged: ReadonlySet<string>): boolean =>
  warnings.every((w, i) => w.severity === "info" || (w.severity === "warning" && acknowledged.has(warningId(w, i))));

/**
 * `acknowledged_warnings` of the activate call: the distinct codes of the
 * acknowledged warnings (the contract types it as `string[]` of codes).
 */
export const acknowledgedCodes = (warnings: ConfigWarning[], acknowledged: ReadonlySet<string>): string[] =>
  [...new Set(warnings.filter((w, i) => w.severity === "warning" && acknowledged.has(warningId(w, i))).map((w) => w.code))];
